import { ExclamationCircleOutlined } from "@ant-design/icons";
import React from "react";

export const errorMessage = (message: string | JSX.Element) => {
  return <div style={{ color: 'red' }}><span><ExclamationCircleOutlined style={{ color: 'red' }} /> </span>{message}</div>;
};
